/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconIndentIncrease = createReactComponent("outline", "indent-increase", "IconIndentIncrease", [["path", { "d": "M20 6l-11 0", "key": "svg-0" }], ["path", { "d": "M20 12l-7 0", "key": "svg-1" }], ["path", { "d": "M20 18l-11 0", "key": "svg-2" }], ["path", { "d": "M4 8l4 4l-4 4", "key": "svg-3" }]]);

export { IconIndentIncrease as default };
//# sourceMappingURL=IconIndentIncrease.mjs.map
